import PubSub from "underpub-js";
import SimpleLightbox from "simplelightbox/dist/simple-lightbox.jquery.js";

var ContentTextMediaTypeOne = function (options) {

	this.options = {
		$el: false,
		baseClass: 'mol-ContentTextMediaTypeOne',
	};

	$.extend(true, this.options, options);

};

ContentTextMediaTypeOne.prototype.init = function () {

	var self = this;

	this.options.$el.find(".el-Carousel__slide img").simpleLightbox({
		sourceAttr: "src",
		scrollZoom: false
	});

};

export default ContentTextMediaTypeOne;